// extracted by mini-css-extract-plugin
export default {"print-only":"CampaignList_print-only__-HIKr","print":"CampaignList_print__AV9L6"};